var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 366.34 366.34",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2a196;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#e88870;}.cls-4{fill:#00214e;}.cls-5,.cls-7{fill:none;}.cls-5{stroke:#00214e;stroke-miterlimit:10;}.cls-6{fill:#ffffff;}.cls-8{fill:#845161;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 69.93,
    y1: 287.28,
    x2: 296.41,
    y2: 287.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6878b1"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboards_Diversity_Avatars_by_Netguru") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.41,282.63a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38a46.35,46.35,0,0,0,12.78-15.09A44.69,44.69,0,0,0,144.55,224a67.91,67.91,0,0,0,.74-9.91c0-5.72-.31-11.44-.37-17.17q-.06-4.76-.1-9.51l2,1,5.2,2.69,2.41.41,27.88,4.74,31.12,5.3.94,32,.31,10.46.15,5.08v.33l12.1,4.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.41,282.63a184.56,184.56,0,0,1-226.48-1l48.66-22.81a46.83,46.83,0,0,0,6.65-3.82c.64-.44,1.28-.9,1.89-1.38,23.55,16.76,55.69,27.33,83.49,14.82,6.62-3,12.7-7.84,16.3-14.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.81,249.12c-10.45.63-21-7.48-31.9-13.75-20.41-11.79-32.42-26.94-28.5-43.8l27.88,4.74,31.12,5.3.94,32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.75,88.46c5.14,20-3.23,38.7-11.3,57-10.21,23.13-24.87,25.88-47.25,33.52-5,1.72-59.22,17.12-59.22,20.48,0-.73-5.31-6-12-12.41-24-22.79-31.89-58-17.61-88.2,19-40.11,75.62-47.28,114.48-37.53,13.4,3.36,26.48,8.66,31.51,22.55C261.88,85.41,262.35,86.94,262.75,88.46Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.98,
    cy: 159.45,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 140.38,
    cy: 159.45,
    r: 15.22
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.6,143.41l4.38,57,66.44,38.82a19.76,19.76,0,0,0,24.68-9.86c9.56-19.58,24.9-50.49,22.88-62-3-17-11-23-11-23l3.33-19.94c1.25-7.51,2.86-15.35,1-22.9-2.13-8.65-8.67-12.35-14.05-18.82-14.16,18.24-37.44,28.55-57.77,39C170,127.23,140.6,143.41,140.6,143.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M215.13,138.55c-.08.34,13.36,36.12,13.36,36.12l-17.94.88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.65,131.62a80.57,80.57,0,0,1,28.13-.79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.7,131.73a55.64,55.64,0,0,1,17.45-1.21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.17,185.55a1.86,1.86,0,0,1,2.68-.5c2.08,1.46,5.88,4.56,11.28,5.63,7.36,1.47,13.74-1.48,15.27.42.86,1.07-.19,2.38-2.2,4.05a19.69,19.69,0,0,1-14.86,3.69c-7.08-1.33-12.4-9.53-12.4-12.44A1.68,1.68,0,0,1,192.17,185.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M123.25,105C142.76,70.44,183.54,49.19,223,53c18.35,1.76,37.82,10,45.47,26.79"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189,141.52c6.11,0,6.11,9.38,0,9.43h-.27c-6.1,0-6.1-9.38,0-9.43H189Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.17,140.13c5.66.05,5.66,8.7,0,8.75h-.25c-5.67,0-5.67-8.7,0-8.75h.25Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M239,64.3a270.32,270.32,0,0,0-62.3,8.5A270.62,270.62,0,0,0,117.7,94.72c4.46-20.63,24.89-39.67,52.74-46.66S225.28,48.23,239,64.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarSvgrepoCom);
export default __webpack_public_path__ + "static/media/avatar-svgrepo-com.dbb215a551c2af10b17b96e9764e045c.svg";
export { ForwardRef as ReactComponent };